//Types should be in const to avoid typos and duplication since it's a string and could be easily miss spelled
// export const REMOVE_ITEM = 'REMOVE_ITEM';
// export const SUB_QUANTITY = 'SUB_QUANTITY';
// export const ADD_QUANTITY = 'ADD_QUANTITY';
// export const ADD_SHIPPING = 'ADD_SHIPPING';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const SHOW_SEARCH = 'SHOW_SEARCH';
export const CHANGE_CATEGORY = 'CHANGE_CATEGORY';

export const OTP_REQUEST = "OTP_REQUEST";
export const OTP_VERIFY = "OTP_VERIFY";
export const SET_USER = "SET_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const CLEAR_CART = "CLEAR_CART";

export const TOGGLE_FAVORITE = "TOGGLE_FAVORITE";

export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";
